mutation EnableSecondFactor($id: Int!, $code: String!) {
  enableSecondFactor(input: { id: $id, code: $code }) {
    success
  }
}
